import * as React from "react";
import CenterDiv from "../core/CenterDiv";

interface IProps extends IOnboardStepProps {}

interface IState {}

const ownerDiscLink = "https://www.ttisurvey.com/302096NNN";
const jasonBookingLink =
  "https://my.setmore.com/bookingpage/759bdc0d-9566-472d-af1a-7a3e4db5b6b4/resourcebookingpage/rdab01468954997319";

class DiscAssessment extends React.Component<IProps, IState> {
  componentDidMount() {
    this.props.allowNextStep(true);
    this.props.onBeforeNextStep(() => {
      this.props.setStepComplete();
    });
  }

  render() {
    return (
      <>
        <div className="panel panel-primary">
          <div className="panel-heading">Owner DISC Assessment</div>
          <div className="panel-body">
            <p>Take advantage of DISC Assessments!</p>
            <ul>
              <li>
                Below is 1 license key included with your CharTec membership.
                This is one of our Top Tier DISC Assessments for{" "}
                <i>Executives</i> Only. Please use it for yourself.
              </li>
              <li>
                Requires your full attention and at least 15-25 minutes to
                complete online.
              </li>
            </ul>
            <p>
              If you're not prepared right now, feel free to return to this page
              later by using the Onboarding button in your 'My Organization'
              page.
            </p>
          </div>
        </div>
        <div className="panel panel-default">
          <div className="panel-heading">
            Accessing the TriMetrix® Executive Assessment
          </div>
          <div className="panel-body">
            <p>
              You have been given an opportunity to take the TriMetrix®
              Executive Assessment through CharTec.
            </p>
            <p>
              This assessment is unique in several ways, so let’s explain how.
              First, this assessment asks specific questions about how you lead,
              direct and manage situations in the day to day business
              environment. Second, the assessment will inquire as to how you
              find inspiration, and core driving attributes in the day to day,
              thereby giving your team a steady view of your talents and gifts.
              Finally, the questions will inquire upon your emotional capacity
              to equalize your thoughts, directions and perspectives under
              potential duress.
            </p>
            <p>
              You’ll want to put yourself in a frame of mind, where you answer
              in complete and bold honesty. Use your gut instinct. The more
              direct you are in your responses, the better result you will get.
              You will need 20 minutes of uninterrupted time, to complete this
              assessment. When you are ready, click the link below.
            </p>
            <CenterDiv>
              <p>
                <a href={ownerDiscLink} target={"_blank"} rel="noopener noreferrer" >
                  {ownerDiscLink}
                </a>
              </p>
            </CenterDiv>
            <CenterDiv>
              <p>
                You may be prompted to enter a Respondent Number, that number
                is:
              </p>
            </CenterDiv>
            <CenterDiv>
              <p>302096NNN</p>
            </CenterDiv>
            <p>
              Once the assessment is complete, you will receive a confirmation
              email. Should you have any problems or accessibility issues,
              please contact us at (866) 544-2772.
            </p>
          </div>
        </div>
        <div className="panel panel-info">
          <div className="panel-heading">Next Steps</div>
          <div className="panel-body">
            <p>
              Once your assessment is complete, please use the button below and
              choose the 'DISC Review' option to schedule time for you to speak
              with Jason Rivas, CharTec's Organizational Development and Culture
              Consultant, so he can review the results with you.
            </p>
            <CenterDiv>
              <a
                href={jasonBookingLink}
                target={"_blank"}
                rel="noopener noreferrer"
                className={"btn btn-theme-primary btn-lg"}
              >
                Schedule Review
              </a>
            </CenterDiv>
            <p>When ready, proceed to the next step.</p>
          </div>
        </div>
      </>
    );
  }
}

export default DiscAssessment;



// WEBPACK FOOTER //
// ./app/javascript/components/onboarding/DiscAssessment.tsx